module.exports = __webpack_public_path__ + "img/cir-exm2.2e7e705b.png";